import React, { useState, useEffect } from "react";
import '../checkout/style/checkout.css';
import Breadcrumb from "../../Component/breadcrumb/Breadcrumb";
import { Button } from 'react-bootstrap';
import CustomerModalbox from "../../Component/Common/CustomerModalbox";
import ITooltip from "../../Component/Common/ITooltip";
import CartModal from "../../Component/Common/CartModal";
import Skeleton from 'react-loading-skeleton';  // Import skeleton
import toast, { Toaster } from 'react-hot-toast';
import { getcart } from "./service/cart.service";
import { deleteCartItem } from "../checkout/service/deletecartItem.serves";
import Proceedcheckout from "../../Component/Common/Proceedcheckout";
import CartEmpty from "../../Component/error/CartEmpty";

function CheckOut() {
    // const notify = () => toast.error('Delet This Data File');
    const [showModal, setShowModal] = useState(false);
    const [modalImage, setModalImage] = useState('');
    const [loading, setLoading] = useState(true);  // Set loading state
    const [cartItems, setCartItems] = useState([]);
    const [cartSummary, setCartSummary] = useState({});
    // const totalItems = cartSummary.total_items || 0;
const totalQty = cartItems.reduce(
  (sum,item)=>
    sum + Number(item.quantity ?? item.qty ?? 0),
  0
);
const subtotal =
  Number(cartSummary?.subtotal ?? cartSummary?.total_amount ?? 0) ||
  cartItems.reduce((sum, item) => {
    const qty = Number(item.quantity ?? item.qty ?? 0);
    const price = Number(item.total_price ?? item.mrp ?? 0);
    return sum + qty * price;
  }, 0);

const loadCart = async () => {
  setLoading(true);

  try {
    const cartType = localStorage.getItem("cartType") || "customer";
    const userId = localStorage.getItem("userId");
    const customerId = localStorage.getItem("customerId");

    if (!userId || !customerId) {
      setCartItems([]);
      setCartSummary({});
      return;
    }

    const data = await getcart(cartType, userId, customerId);

    setCartItems(data.cartItems);
    setCartSummary(data.cartSummary);
  } catch (err) {
    console.log(err);
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
      loadCart();
   }, []);

   const handleImageClick = (image) => {
    setModalImage(image);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

const handleDelete = async (cartId) => {
  try {
    const result = await deleteCartItem(cartId);

    if (result?.success) {
      toast.success("Item deleted successfully");

      // refresh cart after delete
      loadCart();
    }

  } catch (error) {
    console.error("Delete Error:", error);
    toast.error("Failed to delete item");
  }
};

const handleQuantityChange = (cartId, quantity) => {
  const newQty = Number(quantity);

  setCartItems((prevItems) =>
    prevItems.map((item) => {
      if (item.cart_id === cartId) {
        const newTotalPrice = newQty * Number(item.mrp);

        return {
          ...item,
          quantity: newQty,
          total_price: newTotalPrice,
        };
      }

      return item;
    })
  );

  // Update summary also
  setCartSummary((prev) => {
    const updatedItems = cartItems.map((item) =>
      item.cart_id === cartId
        ? {
            ...item,
            quantity: newQty,
            total_price: newQty * Number(item.mrp),
          }
        : item
    );

    return {
      ...prev,
      total_quantity: updatedItems.reduce(
        (sum, item) => sum + Number(item.quantity || 0),
        0
      ),
      subtotal: updatedItems.reduce(
        (sum, item) => sum + Number(item.total_price || 0),
        0
      ),
    };
  });
};

if (!loading && cartItems.length === 0) {
  return <CartEmpty/>;
}

  return (
    <>
 <Breadcrumb/>

     <Toaster position="top-right" reverseOrder={false} />
     
      <div className="TableBoxCheckout">
        <div className="container">
          <div className="row">
            <div className="col-md-9">
              <div className="table-box-content">
                <div className="table-responsive">
                  <table className="table table-lg table-boxrto mb-0" style={{ width: "100%" }}>
                    <thead className="text-center">
                      <tr>
                        <th className="table-header" width="75"> Image </th>
                        <th className="table-header"> Design & Shade </th>
                        <th className="table-header"> Size </th>
                        <th className="table-header"> Order Qty. </th>
                        <th className="table-header"> GST% </th>
                        <th className="table-header"> MRP (<i className="bi bi-currency-rupee"></i>) </th>
                        <th className="table-header"> Amount </th>
                        <th className="table-header" width="90"> &nbsp; </th>
                      </tr>
                    </thead>
                    <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="9">
                          <Skeleton height={60} count={5} />
                        </td>
                      </tr>
                    ) : cartItems.length > 0 ? (
                      cartItems.map((item) => (
                        <tr key={item.id}>
                          <td className="align-middle">
                            <img
                              src={item.design_shade_image}
                              alt={item.design_shade}
                              width="50"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleImageClick(item.design_shade_image)}
                            />
                          </td>

                          <td className="align-middle">
                            <strong>{item.design_shade}</strong>
                            <br />
                            <small>{item.quality_name}</small>
                          </td>

                          <td className="text-center">
                            {item.size}
                          </td>

                            <td className="text-center ">
                              {/* <select
                                className="form-control text-center"
                                value={item.quantity}
                                onChange={(e) =>
                                  handleQuantityChange(item.cart_id, e.target.value)
                                }
                                style={{ fontSize:"13px"}}
                              >
                                {[...Array(20)].map((_, index) => (
                                  <option key={index + 1} value={index + 1}>
                                    {index + 1}
                                  </option>
                                ))}
                              </select> */}

                             <div className="d-flex align-items-center justify-content-center">
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-secondary"
                                      onClick={() =>
                                        handleQuantityChange(
                                          item.cart_id,
                                          Math.max(1, parseInt(item.quantity) - 1)
                                        )
                                      }
                                    >
                                      -
                                    </button>

                                    <input
                                      type="number"
                                      className="form-control text-center mx-2"
                                      value={item.quantity}
                                      min="1"
                                      max="20"
                                      style={{
                                        width: "60px",
                                        fontSize: "13px"
                                      }}
                                      onChange={(e) => {
                                        let qty = parseInt(e.target.value) || 1;

                                        if (qty < 1) qty = 1;
                                        if (qty > 20) qty = 20;

                                        handleQuantityChange(item.cart_id, qty);
                                      }}
                                    />

                                    <button
                                      type="button"
                                      className="btn btn-sm btn-outline-secondary"
                                      onClick={() =>
                                        handleQuantityChange(
                                          item.cart_id,
                                          Math.min(20, parseInt(item.quantity) + 1)
                                        )
                                      }
                                    >
                                      +
                                    </button>
                                  </div>

                            </td>

                          <td className="text-center">
                            {item.gst}%
                          </td>

                          <td className="text-center">
                            ₹{item.mrp.toLocaleString("en-IN")}
                          </td>

                          <td className="text-center">
                            ₹{item.total_price.toLocaleString("en-IN")}
                          </td>

                          <td className="text-center">
                             <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => handleDelete(item.cart_id)}
                              >
                                <i className="bi bi-trash"></i>
                              </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          No Cart Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <div className="box-amount">

                <CustomerModalbox />

                {loading ? ( 
                  <>
                   <div className="d-flex">
                       <span> <Skeleton height={20} width={75} /> </span>
                          <div className="ml-auto">
                       <span className="update-qty"> <Skeleton height={20} width={75} /> </span>
                  </div>
                </div>

                <div className="d-flex">
                   <span> <Skeleton height={20} width={75} /> </span>
                        <div className="ml-auto">
                        <span className="update-qty"> <Skeleton height={20} width={75} /> </span>
                    </div>
                </div>

                <div className="d-flex">
                      <span> <Skeleton height={20} width={75} /> </span>
                         <div className="ml-auto">
                         <span className="update-qty"> <Skeleton height={20} width={75} /> </span>
                     </div>
                </div>

                <div className="d-flex">
                     <span> <Skeleton height={20} width={75} /> </span>
                         <div className="ml-auto">
                         <span className="update-qty"> <Skeleton height={20} width={75} /> </span>
                     </div>
                </div>
              </>
                  
                ):(

              <>
                <div className="d-flex">
                      <span> Total Quantity </span>
                       <div className="ml-auto">
                       <span className="update-qty">
                         {totalQty}
                        </span>
                    </div>
                </div>

              {/* <div className="d-flex">
                   <span> Total Quantity </span>
                    <div className="ml-auto">
                      <span className="update-qty">
                        <i className="bi bi-currency-rupee"></i> {cartSummary.subtotal?.toLocaleString("en-IN")}
                      </span>
                    </div>
              </div> */}

              <div className="d-flex">
                  <span> Subtotal </span>
                   <div className="ml-auto">
                    <span className="update-qty">
                      <i className="bi bi-currency-rupee"></i>  {Number(subtotal).toLocaleString("en-IN")}
                    </span>
                  </div>
              </div>

              <div className="d-flex align-items-center" style={{ borderTop: "1px solid #d9cfcf", borderBottom:"1px solid #d9cfcf", padding: "6px 0" }} >
                  <div style={{ display: "inline-flex", width: "300px" }}>
                    <ITooltip />
                    &nbsp; Avail. Points: <span id="rpoint"> 0 </span>1
                </div>

                <div id="r-point" className="ml-auto mb-0">
                    <div className="input-group input-group-sm">
                      <input
                        type="text"
                        className="form-control border-warning shadow-none"
                        aria-label="Redeem points"
                      />
                      <div className="input-group-append">
                            <button className="btn btn-warning apply" type="button" style={{ background:"#ff935c", color:"#000"}}>
                                  Apply
                            </button>
                         </div>
                       </div>
                    </div>
                 </div>
                </>
                )}

                  {/* <Button className="btn btnyellow mt-1"> PROCEED TO CHECKOUT </Button> */}

                  <div className="mt-1"> 

                        <Proceedcheckout
                          checkoutId={cartSummary?.checkout_id}
                          cartType="fresh"
                        />

                   </div>
                  </div>
                </div>
             </div>
         </div>
      </div>

      {/*------- Cart Image Modal -------*/}
      
      <CartModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        modalImage={modalImage}
      />


    </>
  );
}
export default CheckOut;
